import { Component, Input, OnInit, Optional, Inject } from '@angular/core';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscriber } from 'rxjs';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../@shared/models/response-wrapper.model';
import { LFPDATA } from './search-listing-filter-page.data';
import { plainToClassFromExist } from 'class-transformer';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { FooterPageService } from '../footer/footer-page.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    FIlterSelection,
    SearchPageService,
} from '../search-page/search-page.service';
import { keyframes } from '@angular/animations';

@Component({
    selector: 'app-search-listing-filter-page',
    templateUrl: './search-listing-filter-page.component.html',
    styleUrls: ['./search-listing-filter-page.component.scss'],
})
export class SearchListingFilterPageComponent
    extends RouteExecutor
    implements OnInit
{
    static readonly LP_FILTERS_API = '/lfp';
    static readonly COLP_FILTERS_API = '/clfp';
    errors: ErrorWrapper[] = [];
    @Input() pageData: LFPDATA = new LFPDATA();
    ghostFilter = new Array(4);
    collectionFilterVisible = false;
    @Input() filter: { [p: string]: string | string[] } = {};
    @Input() asHTMLTag = false;
    tab: number = 0;
    rightButtonLInk = '/fn/?action=reset';
    selectedSort: string = SortLabel.Popularity;
    constructor(
        private marcheAPIService: MarcheAPIService,
        applicationRouterService: ApplicationRouterService,
        private activatedRoute: ActivatedRoute,
        private footerService: FooterPageService,
        private router: Router,
        @Optional()
        private dialogRef: MatDialogRef<SearchListingFilterPageComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public dataDialog: any,
        private SearchPageService: SearchPageService
    ) {
        super(applicationRouterService);
        this.processLink('/fn/?value=false&action=footer-show');
        if (
            this.router.routerState.snapshot.url
                .toString()
                .split('?')[0]
                .includes('clfp') &&
            !this.asHTMLTag
        ) {
            this.collectionFilterVisible = true;
        }
        this.activatedRoute.queryParams.subscribe(param => {
            this.filter = param;
            if (dataDialog?.popup === true) {
                this.pageData = this.dataDialog.lfpdata;
            }
            // this.fetchListingFilters();
        });
    }

    ngOnInit(): void {}

    fetchListingFilters() {
        const subscriber = Subscriber.create<ResponseWrapper<LFPDATA> | null>(
            value => {
                if (value?.success) {
                    plainToClassFromExist(this.pageData, value.data);
                } else {
                    plainToClassFromExist(this.errors, value?.errors);
                }
            },
            error => {},
            () => {}
        );

        this.marcheAPIService
            .getRequest<ResponseWrapper<LFPDATA> | null>(
                this.collectionFilterVisible
                    ? SearchListingFilterPageComponent.COLP_FILTERS_API
                    : SearchListingFilterPageComponent.LP_FILTERS_API,
                this.filter
            )
            .subscribe(subscriber);
    }

    backButton() {
        window.history.back();
    }
    onActive(check: number) {
        if (check == 0) {
            this.tab = 0;
        } else if (check == 1) {
            this.tab = 1;
        } else if (check == 2) {
            this.tab = 2;
        } else {
            this.tab = 3;
        }
    }
    sortReset() {
        this.tab = 0;
    }

    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        switch (query.action) {
            case 'filter-selection': {
                let filterSelection = new FIlterSelection(
                    query.action,
                    query.filter,
                    query['child-key'],
                    query['child-label']
                );
                this.SearchPageService.filterSelectionEvent.emit(
                    filterSelection
                );
            }
            case 'sort-selection': {
                let filterSelection = new FIlterSelection(
                    'sort',
                    query.field,
                    query.field,
                    query.order
                );
                this.selectedSort = query?.label.toString();
                this.SearchPageService.filterSelectionEvent.emit(
                    filterSelection
                );
            }
            case 'reset': {
                let filterSelection = new FIlterSelection(
                    query.action,
                    [],
                    [],
                    []
                );
                this.SearchPageService.filterSelectionEvent.emit(
                    filterSelection
                );
            }
            case 'close-popup': {
            }
            default:
                super.executeFunctionLink(id, query);
        }
    }

    closeDialog() {
        this.dialogRef?.close();
    }

    sortingOption = [
        {
            link: `/fn/internal?action=sort-selection&field=createdAt&order=desc&label=${SortLabel.Newest}`,
            active: false,
            title: {
                text: 'Newest',
                color: '#000000',
            },
        },
        {
            link: `/fn/internal?action=sort-selection&field=relevance&order=asc&label=${SortLabel.Popularity}`,
            active: false,
            title: {
                text: 'Popularity',
                color: '#000000',
            },
        },
        {
            link: `/fn/internal?action=sort-selection&field=sellingPrice&order=asc&label=${SortLabel.Price_Low_to_High}`,
            active: false,
            title: {
                text: 'Price Low to High',
                color: '#000000',
            },
        },
        {
            link: `/fn/internal?action=sort-selection&field=sellingPrice&order=desc&label=${SortLabel.Price_High_to_Low}`,
            active: false,
            title: {
                text: 'Price High to Low',
                color: '#000000',
            },
        },
    ];
}
export enum SortLabel {
    Newest = 'Newest',
    Popularity = 'Popularity',
    Price_Low_to_High = 'Price Low to High',
    Price_High_to_Low = 'Price High to Low',
}
